export default function normalizeUser(user) {
  const { plan } = user;
  const isTrialOptIn = plan === 'Premium_trial_opt_in';
  const isTrialOptOut = plan === 'Premium_trial_opt_out';
  const isPatron = plan === 'Premium' || isTrialOptIn || isTrialOptOut;
  return { ...user, isPatron };
}
